type CurrencyConfig = {
  currencySymbol: string;
  fractionDigits: number;
};

export const Currencies = defineCurrencies({
  AUD: { currencySymbol: '$', fractionDigits: 2 },
  CAD: { currencySymbol: '$', fractionDigits: 2 },
  EUR: { currencySymbol: '€', fractionDigits: 2 },
  GBP: { currencySymbol: '£', fractionDigits: 2 },
  IDR: { currencySymbol: 'IDR ', fractionDigits: 0 },
  NZD: { currencySymbol: '$', fractionDigits: 2 },
  USD: { currencySymbol: '$', fractionDigits: 2 },
});

function defineCurrencies<T extends string>(
  obj: Record<T, CurrencyConfig>,
): { [K in T]: CurrencyConfig } {
  return obj;
}
